/**
 * Pokud má obalovací element dataatribut data-toggle-active - pokud uvnitř zaškrtnete radiobuton, přidá se příslušnému nadřazenému labelu class active
 */
function initActiveLabel(element) {
	element.querySelectorAll('[data-toggle-active]').forEach((formInner) => {
		const radios = formInner.querySelectorAll('input[type="radio"]');

		radios.forEach((radio) => {
			// Přidáme active labelu, který obsahuje zaškrtnutý radiobutton
			const parentLabel = radio.closest('label');
			if (parentLabel) {
				if (radio.checked) {
					parentLabel.classList.add('active');
				} else {
					parentLabel.classList.remove('active');
				}
			}

			radio.addEventListener('change', function () {
				// Odstraníme active
				formInner.querySelectorAll('label').forEach((label) => {
					label.classList.remove('active');
				});

				// Přidáme active labelu, který obsahuje zaškrtnutý radiobutton
				const parentLabel = this.closest('label');
				if (parentLabel) {
					parentLabel.classList.add('active');
				}
			});
		});

		const checkboxes = formInner.querySelectorAll('input[type="checkbox"]');

		checkboxes.forEach((checkbox) => {
			// Přidáme/odebereme active labelu, který obsahuje zaškrtnutý checkbox
			const parentLabel = checkbox.closest('label');
			if (parentLabel) {
				if (checkbox.checked) {
					parentLabel.classList.add('active');
				} else {
					parentLabel.classList.remove('active');
				}
			}

			checkbox.addEventListener('change', function () {
				// Přidáme/odebereme active labelu, který obsahuje zaškrtnutý checkbox
				const parentLabel = this.closest('label');
				if (parentLabel) {
					if (checkbox.checked) {
						parentLabel.classList.add('active');
					} else {
						parentLabel.classList.remove('active');
					}
				}
			});
		});
	});
}

export default function () {
	$.nette.ext('active-check-radio-label', {
		init: function () {
			initActiveLabel(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initActiveLabel($el.get(0));
				}
			});
		}
	});
}
